import { useState, useEffect } from 'react';

/**
 * Returns true only after `loading` has been true for at least `delay` ms.
 * This prevents a flash of loading UI for fast loads (<200ms by default).
 */
export function useDelayedLoading(loading: boolean, delay = 200) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional delayed loading toggle
      setShow(false);
      return;
    }
    const id = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(id);
  }, [loading, delay]);

  return show;
}
